import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

function CardSkeleton() {
  return (
    <Box sx={{ borderRadius: '12px', border: '1px solid #e5e7eb', overflow: 'hidden', backgroundColor: '#fff' }}>
      <Skeleton variant="rectangular" height={140} />
      <Box sx={{ p: 2 }}>
        <Skeleton variant="rounded" width={60} height={18} sx={{ mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: '1rem', mb: 0.5 }} />
        <Skeleton variant="text" sx={{ fontSize: '1rem', width: '70%', mb: 1 }} />
        <Skeleton variant="text" sx={{ fontSize: '0.8rem' }} />
        <Skeleton variant="text" sx={{ fontSize: '0.8rem', width: '80%', mb: 1.5 }} />
        <Box sx={{ display: 'flex', gap: 0.5, mb: 1.5 }}>
          <Skeleton variant="rounded" width={50} height={18} />
          <Skeleton variant="rounded" width={60} height={18} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="text" width={40} />
          <Skeleton variant="text" width={30} />
        </Box>
      </Box>
    </Box>
  );
}

export default function LoadingSkeleton({ count = 12 }) {
  return (
    <Grid container spacing={2.5}>
      {Array.from({ length: count }).map((_, i) => (
        <Grid item key={i} xs={12} sm={6} md={4} lg={3}>
          <CardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}
